(function () {
  // Helper function to bind touch or click based on the device
  function bindClick(node, callback) {
    if ('ontouchstart' in document) {
      var event = null;

      node.addEventListener('click', function (e) {
        if (event === null) {
          callback(e, node);
        } else {
          event = null;
        }
      });

      node.addEventListener('touchstart', function (e) {
        e.stopPropagation();
        event = e;
      });

      node.addEventListener('touchend', function (e) {
        e.stopPropagation();

        if (event) {
          callback(event, node);
        }
      });
      node.addEventListener('touchmove', function () {
        event = null;
      });
    } else {
      node.addEventListener('click', function (e) {
        callback(e, node);
      });
    }
  }

  function loopNodeList(nodeList, callback) {
    if (!nodeList) {
      return;
    }

    for (var i = 0; i < nodeList.length; i++) {
      if (nodeList[i].nodeType !== Node.TEXT_NODE) {
        callback(nodeList[i]);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    // CSS Classes
    var activatorClass = 'sa-menu__activator';
    var activatorClassActive = 'sa-menu__activator--active';
    var htmlClassActive = 'sa-menu-is-active';
    var htmlClassPreventScrolling = 'prevent-scroll';
    var menuButtonClass = 'sa-menu__button';
    var menuClassActive = 'sa-menu--active';
    var menuClassEntering = 'sa-menu--entering';
    var menuClassLeaving = 'sa-menu--leaving';
    var menuClassSearchActive = 'sa-menu--active-search';
    var menuClassSearchEntering = 'sa-menu--entering-search';
    var menuClassSearchLeaving = 'sa-menu--leaving-search';
    var menuItemClass = 'sa-menu__item';
    var menuItemClassActive = 'sa-menu__item--active';
    var previewItemClass = 'sa-menu__preview__item';
    var previewItemClassActive = 'sa-menu__preview__item--active';
    var previewItemClassEntering = 'sa-menu__preview__item--entering';
    var searchActivatorClass = 'sa-menu__search-activator';
    var searchActivatorClassActive = 'sa-menu__search-activator--active';
    var submenuItemClass = 'sa-menu__submenu';
    var submenuItemClassActive = 'sa-menu__submenu--active';
    var submenuItemClassEntering = 'sa-menu__submenu--entering';
    var submenuItemClassLeaving = 'sa-menu__submenu--leaving';

    // Prepare data
    var activatorNodes = document.getElementsByClassName(activatorClass);
    var menu = document.querySelector('.sa-menu');
    var menuContent = document.querySelector('.sa-menu__content');
    var mobileMenuToggle = document.querySelector('.sa-menu__mobile-toggle');
    var searchActivatorNodes =
      document.getElementsByClassName(searchActivatorClass);
    var searchForm = document.querySelector('.sa-menu__search__form');
    var searchInput = document.querySelectorAll('.sa-menu__search__input');

    if (
      activatorNodes.length < 1 ||
      searchActivatorNodes.length < 1 ||
      !menu ||
      !menuContent ||
      !searchForm ||
      searchInput.length < 1
    ) {
      // Bail early
      console.log('One or more menu prerequisites are missing');
      return;
    }

    function isMobileMenuVisible() {
      return getComputedStyle(mobileMenuToggle).display !== 'none';
    }

    function activatePreview(id) {
      // Grab all submenus belonging to current menu item
      var previews = menu.querySelectorAll(
        '.' + previewItemClass + '[data-parent-id="' + id + '"]'
      );

      if (isMobileMenuVisible() === false) {
        // Remove all active previews
        loopNodeList(
          menu.querySelectorAll('.' + previewItemClassActive),
          function (node) {
            node.classList.remove(previewItemClassActive);
          }
        );
      }

      // Activate all previews with current parent ID
      loopNodeList(previews, function (node) {
        node.classList.add(previewItemClassActive);
        node.classList.add(previewItemClassEntering);
      });
    }

    function deactivatePreview(id) {
      // Grab all previews belonging to current menu item
      var previews = menu.querySelectorAll(
        '.' + previewItemClass + '[data-parent-id="' + id + '"]'
      );

      // Close all previews with current parent ID
      loopNodeList(previews, function (node) {
        node.classList.remove(previewItemClassActive);
      });
    }

    function activateSubmenu(id) {
      // Grab all submenus belonging to current menu item
      var submenus = menu.querySelectorAll(
        '.' + submenuItemClass + '[data-parent-id="' + id + '"]'
      );

      if (isMobileMenuVisible() === false) {
        // Remove all active submenus
        loopNodeList(
          menu.querySelectorAll('.' + submenuItemClassActive),
          function (activeSubmenuNode) {
            activeSubmenuNode.classList.add(submenuItemClassLeaving);
            activeSubmenuNode.classList.remove(submenuItemClassActive);
          }
        );
      }

      // Activate all submenus with current parent ID
      loopNodeList(submenus, function (submenuNode) {
        submenuNode.classList.add(submenuItemClassActive);
        submenuNode.classList.add(submenuItemClassEntering);
      });
    }

    function deactivateSubmenu(id) {
      // Grab all submenus belonging to current menu item
      var submenus = menu.querySelectorAll(
        '.' + submenuItemClass + '[data-parent-id="' + id + '"]'
      );

      // Close all submenus with current parent ID
      loopNodeList(submenus, function (submenuNode) {
        submenuNode.classList.remove(submenuItemClassActive);
        submenuNode.classList.add(submenuItemClassLeaving);
      });
    }

    function clickMenuItem(node) {
      var isActive = node.classList.contains(menuItemClassActive);

      if (isMobileMenuVisible() === false) {
        // On desktop, remove active class from all sibling menu items
        if (node.parentNode && node.parentNode.childNodes) {
          loopNodeList(node.parentNode.childNodes, function (sibling) {
            if (
              sibling !== node &&
              sibling.classList.contains(menuItemClassActive)
            ) {
              sibling.classList.remove(menuItemClassActive);
            }
          });
        }
      }

      if (isActive) {
        if (node.dataset.hasSubmenu) {
          deactivateSubmenu(node.dataset.id);
        }
        deactivatePreview(node.dataset.id);
      } else {
        if (node.dataset.hasSubmenu) {
          activateSubmenu(node.dataset.id);
        }
        activatePreview(node.dataset.id);
      }

      // Toggle the current menu item as active/inactive
      node.classList.toggle(menuItemClassActive, !isActive);
    }

    function menuTransitionStop() {
      menu.classList.remove(menuClassLeaving);
      menu.classList.remove(menuClassEntering);
      menu.classList.remove(menuClassSearchLeaving);
      menu.classList.remove(menuClassSearchEntering);
      loopNodeList(activatorNodes, function (activator) {
        activator.removeAttribute('disabled');
      });
      loopNodeList(searchActivatorNodes, function (activator) {
        activator.removeAttribute('disabled');
      });
    }

    function menuItemOnHoverEnter(node) {
      activatePreview(node.dataset.id);
    }

    function submenuTransitionStop(node) {
      node.classList.remove(submenuItemClassEntering);
      node.classList.remove(submenuItemClassLeaving);
    }

    function previewTransitionStop(node) {
      node.classList.remove(previewItemClassEntering);
    }

    /*
     * Menu control functions
     * Search control functions
     */

    function hideMenu() {
      document.documentElement.classList.remove(
        htmlClassActive,
        htmlClassPreventScrolling
      );
      // We are transitioning the menu away
      menu.classList.add(menuClassLeaving);
      menu.classList.remove(menuClassActive);
      loopNodeList(activatorNodes, function (activator) {
        activator.classList.remove(activatorClassActive);
        // Prevents double tap
        activator.setAttribute('disabled', 'disabled');
      });
    }

    function hideSearch() {
      // We are transitioning the menu away
      menu.classList.add(menuClassSearchLeaving);
      menu.classList.remove(menuClassSearchActive);
      loopNodeList(searchActivatorNodes, function (activator) {
        activator.classList.remove(searchActivatorClassActive);
        // Prevents double tap
        activator.setAttribute('disabled', 'disabled');
      });
    }

    // Lazyload images from menu separately via custom dataset to reduce load
    function lazyloadMenuImages() {
      // Don't load images on mobile viewports when they're hidden anyway
      if (window.matchMedia('only screen and (max-width: 767px)').matches) {
        return;
      }
    }

    function showMenu() {
      hideSearch();
      document.documentElement.classList.add(
        htmlClassActive,
        htmlClassPreventScrolling
      );
      // We are transitioning the menu in
      menu.classList.add(menuClassEntering, menuClassActive);
      loopNodeList(activatorNodes, function (activator) {
        activator.classList.add(activatorClassActive);
        // Prevents double tap
        activator.setAttribute('disabled', 'disabled');
      });
      lazyloadMenuImages();
    }

    function toggleMenu() {
      // Switch classes on the menu when the activator is clicked
      var isActive =
        document.documentElement.classList.contains(htmlClassActive);

      if (isActive) {
        hideMenu();
      } else {
        showMenu();
      }
    }

    function showSearch() {
      hideMenu();
      menu.classList.add(menuClassSearchEntering, menuClassSearchActive);
      loopNodeList(searchActivatorNodes, function (activator) {
        activator.classList.add(searchActivatorClassActive);
        // Prevents double tap
        activator.setAttribute('disabled', 'disabled');
      });
      loopNodeList(searchInput, function (input) {
        input.focus();
      });
    }

    function toggleSearch(e, node) {
      // Switch classes on the menu when the activator is clicked
      var isActive = menu.classList.contains(menuClassSearchActive);
      if (isActive && node.classList.contains(menuButtonClass)) {
        // When menu is active, click on the search icon in the main nav performs submit
        var submitButton = searchForm.querySelector('[type=submit]');

        if (submitButton) {
          submitButton.click();
        }

        return;
      }

      if (isActive) {
        hideSearch();
      } else {
        showSearch();
      }
    }

    /*
     * Swipe control functions
     */

    var touchX = null;
    var touchY = null;
    var diffX = null;
    var diffY = null;
    var touchTime = 0;
    // If touch is not released until this many milliseconds, don't do anything
    var touchReleaseTimeThreshold = 500;
    var minimumSidewaysPixelsToInteract = 50;

    function resetTouch() {
      touchX = null;
      touchY = null;
      diffX = null;
      diffY = null;
      touchTime = 0;
    }

    function handleTouchStart(e) {
      if (e.touches && e.touches.length < 1) {
        return;
      }

      // Get threshold for the beginning of swipe, it must start in the first 5% of the screen
      var threshold = window.outerWidth / 20;
      // Grab the position where the user started swiping
      var currentTouchX = e.touches[0].clientX;
      // Check if the threshold for swiping is greater than the swipe start
      // Check from both sides - left and right (using the window width for reference)
      if (
        currentTouchX < threshold ||
        currentTouchX > window.outerWidth - threshold
      ) {
        // Note the time of the start
        touchTime = Date.now();
        // Save the values for later use
        touchX = currentTouchX < threshold ? 0 : window.outerWidth;
        touchY = e.touches[0].clientY;

        // Expire the state after a preset time
        setTimeout(resetTouch, touchReleaseTimeThreshold);
      }
    }

    function handleTouchMove(e) {
      if (touchTime === 0 || !e.touches || e.touches.length < 1) {
        return;
      }

      // Compute difference from the start
      diffX = e.touches[0].clientX - touchX;
      diffY = e.touches[0].clientY - touchY;
    }

    function handleTouchEnd() {
      if (touchTime === 0) {
        return;
      }
      // Grab the absolute amounts of swipe difference
      var absDiffX = Math.abs(diffX);
      var absDiffY = Math.abs(diffY);

      var isSideways = absDiffX > absDiffY;
      // Make sure touchTime is defined
      // Check that the user swiped more than the defined threshold for interaction
      // Make sure it is a sideways swipe, not downards/upwards
      // Make sure we have not run out of time
      if (
        !touchTime ||
        absDiffX < minimumSidewaysPixelsToInteract ||
        !isSideways ||
        Date.now() - touchTime > touchReleaseTimeThreshold
      ) {
        resetTouch();
        return;
      }

      // diffX determines in which direction is the user swiping
      if (diffX > 0) {
        // Swiping right
        showMenu();
      } else {
        // Swiping left
        hideMenu();
      }
    }

    function supportTouchSwipe() {
      if (!('ontouchstart' in document)) {
        return;
      }

      document.addEventListener('touchstart', handleTouchStart, false);
      document.addEventListener('touchmove', handleTouchMove, false);
      document.addEventListener('touchend', handleTouchEnd, false);
    }

    /*
     * Initialization logic
     */

    // Register animation callbacks
    menu.addEventListener('transitionend', menuTransitionStop);
    loopNodeList(
      menu.querySelectorAll('.' + submenuItemClass),
      function (node) {
        node.addEventListener('transitionend', function () {
          submenuTransitionStop(node);
        });
      }
    );
    loopNodeList(
      menu.querySelectorAll('.' + previewItemClass),
      function (node) {
        node.addEventListener('transitionend', function () {
          previewTransitionStop(node);
        });
      }
    );

    loopNodeList(menu.querySelectorAll('.' + menuItemClass), function (node) {
      node.addEventListener('mouseenter', function () {
        menuItemOnHoverEnter(node);
      });
    });

    // Register clicks on the menu activators - e.g. burger, mobile arrow toggle, search icons
    loopNodeList(activatorNodes, function (activator) {
      bindClick(activator, toggleMenu);
    });
    loopNodeList(searchActivatorNodes, function (activator) {
      bindClick(activator, toggleSearch);
    });

    // Register clicks on the menu items
    loopNodeList(menu.querySelectorAll('.' + menuItemClass), function (node) {
      bindClick(node, function () {
        clickMenuItem(node);
      });
    });

    // Register functionality to support swiping the menu
    supportTouchSwipe();

    // Event resize:width is defined in WLC theme in scripts/init-js/
    window.addEventListener('resize:width', function () {
      if (isMobileMenuVisible()) {
        // Mobile does not need to reset state
        return;
      }

      // Reset menu items
      loopNodeList(
        menu.querySelectorAll('.' + menuItemClassActive),
        function (node) {
          node.classList.remove(menuItemClassActive);
        }
      );

      // Reset sub menu
      loopNodeList(
        menu.querySelectorAll('.' + submenuItemClass),
        function (node) {
          node.classList.remove(submenuItemClassActive);
          node.classList.remove(submenuItemClassLeaving);
          node.classList.remove(submenuItemClassEntering);
        }
      );

      // Reset previews
      loopNodeList(
        menu.querySelectorAll('.' + previewItemClass),
        function (node) {
          node.classList.remove(previewItemClassActive);
          node.classList.remove(previewItemClassEntering);
        }
      );
    });
  });
})();
